import {types} from "../../types/types";

const INITIAL_STATE = {
    init_steps: null,
    flow_steps: null,
    loading: false
}


export const botReducer = (state = INITIAL_STATE, action) => {

    const {type, payload} = action;

    switch (type) {

        case types.botInitSteps: {
            return {
                ...state,
                init_steps: [...payload],
            }
        }
        case types.botFlowSteps: {
            return {
                ...state,
                flow_steps: [...payload],
            }
        }
        case types.botSteps: {
            return {
                ...state,
                bot_steps: [...payload],
            }
        }
        default:
            return state;
    }
}
